import { Component, OnDestroy } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeWhile } from 'rxjs';

import { IReport, ReportsService } from '@app/core/reports';
import { ReportDialogComponent } from '../report-dialog/report-dialog.component';
import { YesNoDialogComponent } from '@app/shared';

@Component({
  selector: 'app-report-list',
  templateUrl: './report-list.component.html',
})
export class ReportListComponent implements OnDestroy {
  public records$: Subject<IReport[]>;
  public selectedReports: IReport[];

  private destroyed: boolean;

  constructor(
    private service: ReportsService,
    private dialogService: DialogService
  ) {
    this.selectedReports = [];
    this.records$ = new Subject();
    this.loadReports();
  }

  private loadReports(): void {
    this.selectedReports = [];
    this.service
      .getReports()
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((records) => {
        this.records$.next(records);
      });
  }

  public newReport(): void {
    this.dialogService
      .open(ReportDialogComponent, {
        header: 'Nuevo informe',
        height: '600px',
        width: '800px',
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((report) => {
        if (report) {
          this.loadReports();
        }
      });
  }

  public deleteSelected(): void {
    this.dialogService
      .open(YesNoDialogComponent, {
        height: '300px',
        width: '300px',
        header: 'Eliminar informe/s',
        data: {
          message: '¿Eliminar informes seleccionados?',
        },
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((result) => {
        if (result) {
          this.service
            .deleteReports(this.selectedReports.map((r) => r.id))
            .pipe(takeWhile(() => !this.destroyed))
            .subscribe(() => {
              this.loadReports();
            });
        }
      });
  }

  public onRowEdit(report): void {
    this.dialogService
      .open(ReportDialogComponent, {
        height: '600px',
        width: '800px',
        header: 'Editar informe',
        data: {
          report,
        },
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((report) => {
        if (report) {
          this.loadReports();
        }
      });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }
}
